<template>
  <div :class="{ 'mb-4': !noGutter }">
    <slot
      :attrs="{
        ...$attrs,
        errorMessages: activeErrorMessages,
        success: isValid
      }"
      :on="$listeners"
      :hasErrors="hasErrors"
    />
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';

export default {
  name: 'FormGroup',
  mixins: [singleErrorExtractorMixin],
  props: {
    noGutter: {
      type: Boolean,
      default: false
    }
  }
};
</script>
